import {useQuery} from 'react-query';
import getAgentStoreDetail from '.';

export const useGetAllAgentDetail = (guid?: string) => {
  const {data, isLoading, refetch} = useQuery(
    ['get-Agent-Detail', guid],
    () => getAgentStoreDetail(guid as string),
    {enabled: guid ? true : false},
  );

  return {
    agentDetail: data,
    isLoadingGetAgentDetail: isLoading,
    refetchGetAgentDetail: refetch,
  };
};
